import { useToast } from '@/features/toasts/useToast'
import { useDeleteProviderMutation } from '../api'
import type { ProviderDelete } from '../types'

export const useDeleteProvider = () => {
  const [trigger] = useDeleteProviderMutation({
    fixedCacheKey: 'delete-provider',
  })
  const toast = useToast()

  const deleteProvider = async (body: ProviderDelete) => {
    try {
      await trigger(body).unwrap()
      toast.success('Provider deleted')
      return true
    } catch {
      toast.error('Failed to delete provider')
      return false
    }
  }

  return { deleteProvider }
}
